import React from 'react';
import {
  DialogSecondaryAction,
  DialogTitleWithCloseAction,
  useDialog
} from '@ianesthesie-kit/redux';
import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  Stack
} from '@mui/material';
import { TranslatedText, useRouterPush } from '@ianesthesie-kit/core';
import type { RootState } from '@/store';
import { patientBffApi } from '@/modules/baseApi';
import { AppConfigService } from '@/config';
import { ZeroPaddingDialogContainer } from './common';
import { useAppSelector } from '@/hooks';

const toKey = (tail: string) => `patient-app.error.noDocuments.${tail}`;

const selectQuestionnaireStatus = (state: RootState) =>
  state.questionnaire.status ||
  state[patientBffApi.reducerPath].queries['questionnaireStatus(undefined)']
    ?.data;

export const NoDocumentsDialog = () => {
  const { closeDialog } = useDialog();
  const push = useRouterPush();
  // call appStore directly in order to avoid circular dep
  const questionnaireStatus = useAppSelector(selectQuestionnaireStatus);

  const questionnaireAvailable =
    !!questionnaireStatus && questionnaireStatus !== 'COMPLETED';

  const closeAndRedirect = (path: string) => () => {
    push(path);
    closeDialog();
  };

  return (
    <ZeroPaddingDialogContainer>
      <DialogTitleWithCloseAction onClose={closeDialog}>
        <TranslatedText id={toKey('title')} />
      </DialogTitleWithCloseAction>
      <DialogContent>
        <DialogContentText>
          <TranslatedText id={toKey('body1')} />
          <br />
          {questionnaireAvailable && (
            <>
              <TranslatedText id={toKey('body2')} />
              <br />
            </>
          )}
          <TranslatedText id={toKey('body3')} />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Stack direction="row" gap={1}>
          <DialogSecondaryAction
            component="a"
            target="_blank"
            href={AppConfigService.getInstance().getLink('support')}
            onClick={closeAndRedirect('/')}
          >
            <TranslatedText id="app.contactUs" />
          </DialogSecondaryAction>
          {questionnaireAvailable && (
            <Button onClick={closeAndRedirect('/questionnaire')}>
              <TranslatedText id={toKey('goToQuestionnaire')} />
            </Button>
          )}
          {!questionnaireAvailable && (
            <Button onClick={closeAndRedirect('/')}>
              <TranslatedText id="app.back" />
            </Button>
          )}
        </Stack>
      </DialogActions>
    </ZeroPaddingDialogContainer>
  );
};
